<div class="upload-dialog">

  <h2 mat-dialog-title class="dialog-header">
    <mat-icon class="header-icon">upload_file</mat-icon>
    <span>Carica documento</span>
  </h2>

  <mat-dialog-content>
    <p class="dialog-subtitle">Stai per caricare il seguente file:</p>

    <div class="file-chip">
      <mat-icon class="file-chip-icon">insert_drive_file</mat-icon>
      <div class="file-chip-info">
        <span class="file-chip-name">{{ data.fileName }}</span>
        <span class="file-chip-meta">{{ data.fileSize }}</span>
      </div>
    </div>

    <p class="mt-3">Il nostro team potrà visualizzarlo. Confermi?</p>
  </mat-dialog-content>

  <mat-dialog-actions class="mt-3 dialog-actions">
    <button mat-button mat-dialog-close class="back-button">
      <mat-icon>arrow_back</mat-icon>
      Indietro
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      class="confirm-button">
      <mat-icon>check</mat-icon>
      Confermo
    </button>
  </mat-dialog-actions>

</div>
